"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pako_1 = require("pako");

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));

var DeflateDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(DeflateDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(DeflateDecoder);

  function DeflateDecoder() {
    (0, _classCallCheck2.default)(this, DeflateDecoder);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DeflateDecoder, [{
    key: "decodeBlock",
    value: function decodeBlock(buffer) {
      return (0, pako_1.inflate)(new Uint8Array(buffer)).buffer;
    }
  }]);
  return DeflateDecoder;
}(basedecoder_js_1.default);

exports.default = DeflateDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztJQUVxQkEsYzs7Ozs7Ozs7Ozs7O1dBQ25CLHFCQUFZQyxNQUFaLEVBQWtCO01BQ2hCLE9BQU8sb0JBQVEsSUFBSUMsVUFBSixDQUFlRCxNQUFmLENBQVIsRUFBZ0NBLE1BQXZDO0lBQ0Q7OztFQUh5Q0Usd0I7O0FBQTVDQyIsIm5hbWVzIjpbIkRlZmxhdGVEZWNvZGVyIiwiYnVmZmVyIiwiVWludDhBcnJheSIsImJhc2VkZWNvZGVyX2pzXzEiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL2NvbXByZXNzaW9uL2RlZmxhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=